import $ from "jquery";

/**
 * example class for upload observer
 */

class S3UploadObserver {

    /**
     * @param totalPercent
     * @param file
     * @param filePercent
     */
    uploadProgress(totalPercent, file, filePercent) {
        console.log("progress: " + total)
    }

    uploadComplete() {
        console.log("upload complete")
    }

    uploadFailed() {
        console.log("upload failed")
    }
}


class S3Upload {

    /**
     * @param variant: {Object}
     * @param observer {S3UploadObserver}
     */
    constructor(variant, observer) {
        // observer will be notified about upload status, see example above
        this.variant = variant
        this.observer = observer

        // list of files to upload
        this.files = []
        this.progress = []

        // number of parallel uploads
        this.concurrency = 5
        this.videoUpload = false
    }

    /**
     *
     * @param method {String}
     * @param row {Number}
     * @param files {Array} [{name: '<filename>', payload: <file object>}, ...] (filenames will have <variant uuid> and optional <revision> added in front
     */
    enqueue(method, row, files) {
        let that = this
        if (method === 'videos') {
            this.videoUpload = true
        }

        files.forEach((file) => {
            that.files.push({
                'method': method,
                'row': row,
                'file': file
            })
        })
    }

    upload() {
        if (!this.variant?.uuid) {
            console.warn("[S3Upload] No variant uuid (product create may have failed or timed out); upload aborted")
            this.observer.uploadFailed()
            return
        }

        let data = {
            source_image_count: this.files.length
        }

        if (this.videoUpload) {
            data.video_upload = "true"
        }

        const that = this
        const xhr = new XMLHttpRequest()

        const csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content')

        const url = `/products/${this.variant.uuid}/upload`

        xhr.open("PATCH", url, true)
        xhr.setRequestHeader("Content-Type", "application/json")
        xhr.setRequestHeader('x-csrf-token', csrfToken)

        xhr.onload = function () {
            let result = JSON.parse(this.responseText)

            that.variant = result.variant
            that.uploadHost = result.upload_host
            that.presignedData = result.signed_data

            that._uploadFiles()
        }

        xhr.send(JSON.stringify(data))
    }

    _uploadFiles() {
        const that = this

        // counter to determine when upload is complete
        this.todo = this.files.length

        // counter for concurrent uploads
        this.activeUploads = 0

        // can be set if error occurs, will stop further uploads
        this.hasErrors = false

        this.progress = this.files.map((o) => 0)

        let index = 0

        // start file uploads
        that.uploadInterval = setInterval(function () {
            // stop interval if everything is done or an error occured
            if (index >= that.files.length || that.hasErrors === true) {
                clearInterval(that.uploadInterval)
                return
            }

            // check concurrency
            if (that.activeUploads < that.concurrency) {
                that._uploadFile(index)
                index += 1
            }
        }, 100)
    }


    /**
     * upload one file to an s3 bucket
     *
     * @param index {Number} index of file object to upload
     */
    _uploadFile(index) {
        this.activeUploads += 1

        const xhr = new XMLHttpRequest()
        const that = this

        xhr.upload.onprogress = (e) => {
            that.updateProgress(index, e.loaded * 100.0 / e.total)
        }

        xhr.onreadystatechange = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 201) {
                    that.activeUploads -= 1
                    that.todo -= 1

                    that.updateProgress(index, 100)

                    // TRIGGER PROCESS VARIANT WHEN ALL IMAGES ARE UPLOADED
                    if (that.todo === 0) {
                        that.finish(that.variant)
                    }
                } else {
                    // Error. Inform the user
                    console.log("Error during upload")
                    console.log(xhr.status)
                    console.log(xhr.responseText)

                    // stop concurrency interval
                    that.hasErrors = true

                    // notify caller
                    that.observer.uploadFailed()
                }
            }
        }

        const file = this.files[index]
        const signedData = this.presignedData[file.method]

        const formData = new FormData()

        formData.append("acl", signedData["acl"])
        formData.append("policy", signedData["policy"])
        formData.append("success_action_status", signedData["success_action_status"])
        formData.append("x-amz-algorithm", signedData["x-amz-algorithm"])
        formData.append("x-amz-credential", signedData["x-amz-credential"])
        formData.append("x-amz-date", signedData["x-amz-date"])
        formData.append("x-amz-signature", signedData["x-amz-signature"])


        let key = signedData["key"]
        // Set upload key
        switch (file.method) {
            case 'frames':
            case 'videos':
                key = key.replace('${filename}', `${this.variant.revision}/row-${file.row}/\${filename}`)
                break
            case 'stills':
                key = key.replace('${filename}', `${this.variant.revision}/2-additional/\${filename}`)
                break
            case 'gallery':
                // For storage version 1, gallery images go to 3-gallery folder
                key = key.replace('${filename}', `${this.variant.revision}/3-gallery/\${filename}`)
                break
            case 'images':
                // keep (for storage version 2 gallery projects - flat structure)
                break
            default:
                break
        }

        formData.append("key", key)

        // Actual file has to be appended last
        formData.append('file', file.file)

        const url = `//${this.uploadHost}`
        xhr.open("POST", url, true)
        xhr.send(formData)
    }

    /**
     * calculate total upload progress and notify observer
     *
     * @param fileIndex {Number} index of the file
     * @param percent {Number} percent of file uploaded
     */
    updateProgress(fileIndex, percent) {
        this.progress[fileIndex] = percent
        let total = Math.round(this.progress.reduce((acc, cur) => acc + cur, 0) / this.progress.length)
        this.observer.uploadProgress(total, this.files[fileIndex]['file'], percent)
    }


    /**
     * notify app about completed upload and notify observer
     *
     * @param variant {Object}
     */
    finish(variant) {
        const that = this
        const url = `/products/${variant.uuid}/process`;

        $.ajax({
            url,
            type: "POST",
            data: {}
        }).done(function (xhr) {
            console.log("variant process started")
            that.observer.uploadComplete()
        }).fail(function (xhr) {
            console.log("error variant process")
            that.observer.uploadFailed()
        })
    }
}

export { S3Upload, S3UploadObserver };
